import { Component } from '@angular/core';

/**
 * Title, Help & FAQ link and the Overview / Usage / Transactions tabs shared by
 * all three billing pages. Page-specific controls (Usage's date range picker)
 * are projected in and sit to the left of Help & FAQ.
 */
@Component({
  selector: 'app-billing-header',
  standalone: false,
  templateUrl: './billing-header.html',
})
export class BillingHeader {}
